<template>
  <b-dropdown
    menu-class="options-dropdown"
    lazy
    :disabled="disabled"
  >
    <template #button-content>
      <strong
        class="flex-grow-1 text-left"
      >{{ capitalizeFirstLetter(filter) }}</strong>
      <span class="ml-5">({{ selectedOptions.length }}/{{ alphabeticallySortedList.length }})</span>
    </template>
    <b-dropdown-form class="dropdown-options">
      <small> <b-link @click="selectAll">Select all</b-link> / <b-link @click="deselectAll">Deselect all</b-link></small>
    </b-dropdown-form>
    <b-dropdown-form
      v-for="(option, index) in alphabeticallySortedList"
      :key="index"
    >
      <b-form-checkbox
        :id="`${filter}-checkbox-${option[keyProperty]}`"
        :name="`${filter}-checkbox-${option[keyProperty]}`"
        :checked="selectedOptions.includes(option[keyProperty])"
        @change="toggleOptionSelection(option[keyProperty], $event)"
        size="xl"
        class="option-checkbox"
        :data-test="`${filter}-list-item-checkbox`"
      >
        {{ option[valueProperty] }}
      </b-form-checkbox>
    </b-dropdown-form>
  </b-dropdown>
</template>
<script>
import textHelper from '@/core/mixins/textHelper';

export default {
  name: 'BaseFilterDropdown',
  mixins: [
    textHelper,
  ],
  props: {
    filter: {
      type: String,
      required: true,
      default: '',
    },
    optionsList: {
      type: Array,
      required: true,
      default: () => [],
    },
    keyProperty: {
      type: String,
      required: true,
      default: 'id',
    },
    valueProperty: {
      type: String,
      required: true,
      default: 'name',
    },
    selectedOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    alphabeticallySortedList() {
      if (this.optionsList.length === 0) return [];
      return this.sortListAlphabetically(this.optionsList, this.valueProperty);
    },
  },
  methods: {
    sortListAlphabetically(list, prop) {
      return list.sort((a, b) => {
        if (a[prop] < b[prop]) { return -1; }
        if (a[prop] > b[prop]) { return 1; }
        return 0;
      });
    },
    toggleOptionSelection(keyProperty, isChecked) {
      this.$emit('updatedSelectedOptions', keyProperty, isChecked);
    },
    selectAll() {
      this.$emit('selectAllOptions');
    },
    deselectAll() {
      this.$emit('deselectAllOptions');
    },
  },
};
</script>
<style lang="scss">
button.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dropdown-options {
  background: #dfe3e8;
  text-align: center;
  padding-bottom: 3px;
}
.options-dropdown {
  min-width: 250px;
  height: 300px;
  overflow: scroll;
  background: rgb(255, 255, 255);
  padding-top: 0;
  form.b-dropdown-form {
    padding: 0.25rem 0.5rem;
    outline: none !important;
  }
  .option-checkbox {
    padding: 0.25em 1.5em;
    &:hover{
      background: rgba(154, 169, 172, 0.2);
    }
    label {
      width: 100%;
    }
  }
}
</style>
